import { ButtonBase, makeStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { Text } from "../../Primitives";
const useStyles = makeStyles((theme) => ({
    root: {
        height: 52,
        position: "relative",
        display: "flex",
        alignItems: "left",
        justifyContent: "left",
        "&.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.26)"
        }
    },
    big: {
        backgroundColor: theme.palette.type === "dark" ? "#425784" : "#3A5898",
        borderRadius: "26px",
        width: "100%",
        // paddingRight: "36px",
        display: "flex",
        flexDirection: "row"
    },
    small: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "50%",
        width: 48
    },
    brand: {
        color: theme.palette.common.white,
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: "0.25px",
        lineHeight: "20px",
        paddingLeft: "36px",
        alignSelf: "center",
        width: "100%"
    },
    logotype: {
        display: "flex",
        paddingRight: "10px",
        "& img": {
            height: 24,
            width: 24
        }
    }
}));
export const LoginWithFacebookButton = (props) => {
    const classes = useStyles(props);
    const { actionText, href, onClick, disabled, variant } = props;
    const buttonBaseProps = { href, onClick, disabled };
    return (React.createElement(ButtonBase, Object.assign({}, buttonBaseProps, { className: classNames(classes.root, {
            [classes.big]: variant === "big",
            [classes.small]: variant === "small"
        }) }),
        actionText && React.createElement(Text, { className: classes.brand }, actionText),
        React.createElement("div", { className: classes.logotype },
            React.createElement("img", { alt: "facebook", src: "/assets/brands/facebook-f.svg" }))));
};
//# sourceMappingURL=Facebook.js.map